module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_ny_ycx.7ee0decd.png";